import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDomainStatus } from '../../../../helpers/DomainStatus';
import Table from '../../../atoms/table/Table';
import CopyrightCheckerDossierOverviewTableHeader from '../../../molecules/table/CopyrightCheckerDossierOverviewTableHeader';
import CopyrightCheckerDossierOverviewTableRow from '../../../molecules/table/CopyrightCheckerDossierOverviewTableRow';
import NoDataTableRow from '../../../molecules/table/NoDataTableRow';
import SkeletonTableRow from '../../../molecules/table/SkeletonTableRow';
function CopyrightCheckerDossierOverviewTable({ data = [], loading = false, }) {
    const { t } = useTranslation();
    return (_jsxs(Table, { children: [_jsx(CopyrightCheckerDossierOverviewTableHeader, {}), loading && _jsx(SkeletonTableRow, {}), !loading && (_jsx(_Fragment, { children: data.length === 0 ? (_jsx(NoDataTableRow, { message: t('copyright_checker.no_results') })) : (data.map(dossier => {
                    return CopyrightCheckerDossierOverviewTableRowFactory(dossier);
                })) }))] }));
}
const CopyrightCheckerDossierOverviewTableRowFactory = (item) => {
    if (typeof item.domain === 'string') {
        item = item;
        return (_jsx(CopyrightCheckerDossierOverviewTableRow, { domain: item.domain, id: item.id, isDomain: true, status: getDomainStatus(item), detections_count: item.detections_count, full_detections_count: item.full_detections_count, embedded_detections_count: item.embedded_detections_count }, item.id));
    }
    item = item;
    return (_jsx(CopyrightCheckerDossierOverviewTableRow, { domain: item.domain.domain, id: item.id, status: item.status, detections_count: item.detections_count, full_detections_count: item.full_detections_count, embedded_detections_count: item.embedded_detections_count }, item.id));
};
export default memo(CopyrightCheckerDossierOverviewTable);
